var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchAgencyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 27H33.8C34.9201 27 35.4802 27 35.908 27.218C36.2843 27.4097 36.5903 27.7157 36.782 28.092C37 28.5198 37 29.0799 37 30.2V37M29 37V22.2C29 21.0799 29 20.5198 28.782 20.092C28.5903 19.7157 28.2843 19.4097 27.908 19.218C27.4802 19 26.9201 19 25.8 19H22.2C21.0799 19 20.5198 19 20.092 19.218C19.7157 19.4097 19.4097 19.7157 19.218 20.092C19 20.5198 19 21.0799 19 22.2V37M38 37H18M22.5 23H25.5M22.5 27H25.5M22.5 31H25.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#D0E0E8",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchAgencyIcon);
export default __webpack_public_path__ + "static/media/switchAgencyIcon.86567564bd03955ab44e73990b154d14.svg";
export { ForwardRef as ReactComponent };